import { Save } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const CreateGroupModal = ({ onClose }) => {
    // State for form data
    const [formData, setFormData] = useState({
        groupName: '',
        groupCode: '',
        course_id: ''
    });
    // State to hold course select
    const [courses, setCourses] = useState([]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        try {
            const payload = {
                groupName: formData.groupName,
                groupCode: formData.groupCode,
                course_id: parseInt(formData.course_id, 10)
            };

            console.log('Payload to create group:', payload);
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/courses/createGroup`,
                payload
            );
            console.log('Grupa została utworzona:', response.data);

            if (response.status >= 200 && response.status < 300) {
                onClose();
            }

        } catch (err) {
            console.error('Błąd podczas tworzenia grupy:', err);
        }
    };

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/getData/courses`);
                setCourses(response.data);
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        };

        fetchCourses();
    }, []);

    return (
        <div className="module-modal-overlay">
            <div className="module-modal-content">
                <h3 className="modal-title">Utwórz nową grupę</h3>

                <div className="form-group">
                    <label>Unikalny kod grupy</label>
                    <input
                        className='form-input'
                        type="text"
                        placeholder="Wprowadź unikalny kod grupy"
                        name="groupCode"
                        value={formData.groupCode}
                        onChange={handleInputChange}
                    />
                </div>
                <div className="form-group">
                    <label>Nazwa grupy</label>
                    <input
                        className='form-input'
                        type="text"
                        placeholder="Wprowadź nazwę grupy"
                        name="groupName"
                        value={formData.groupName}
                        onChange={handleInputChange}
                    />
                </div>
                <div className="form-group">
                    <label>Kurs dla grupy:</label>
                    <select
                        name='course_id'
                        className="form-input"
                        value={formData.course_id}
                        onChange={handleInputChange}
                    >
                        <option value="">-- Wybierz kurs --</option>
                        {courses.map(course => (
                            <option key={course.course_id} value={course.course_id}>
                                {course.course_name} {course.academic_year}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="modal-actions">
                    <button onClick={onClose} className="button-secondary">Anuluj</button>
                    <button onClick={handleSubmit} className="button-primary">
                        <Save size={16} />
                        Zapisz
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CreateGroupModal;